// extracted by mini-css-extract-plugin
export default {"titleLoadingSkeleton":"HeaderLoading-module__titleLoadingSkeleton__z76UhLe","metadataLoadingSkeleton":"HeaderLoading-module__metadataLoadingSkeleton__eLNX5Gz"};